<adapt-feature-guidance [configItem]="configItem">
    <p>To continue to work towards the vision of the organisation, we set resilient business goals. These are 3-5-year goals across the
        business. Just like the vision, resilient business goals support communication and motivation across the business. Setting clear
        goals helps focus energy, reduce confusion, and support decision making.</p>
    <p>Enabling this feature will allow you to define the organisation's resilient business goals.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem"></adapt-feature-configuration>
